import { setupForDark } from '@theme';
import classNames from 'classnames';
import { ReactNode } from 'react';

const Card = ({ children, className = '' }: { children: ReactNode; className?: string }) => {
  return (
    <div className={classNames(className, 'p-md', 'rounded-sm', setupForDark('bg-primary'))}>
      {children}
    </div>
  );
};

export default Card;
